import PubSub, { AppDispatcher } from 'services/PubSub/';
import { actionsType } from 'config/constants';
import ProductService from 'services/Product/';
import ListService from 'services/AccountLists/';
import ProductFactory from 'factories/Products';

const productsFactory = (products, promotions) => {
    if (!(products && products[0])) return [];
    return products.map(product => {
        return ProductFactory.setPromotions(ProductFactory.create(product), promotions);
    });
};

const productFactory = (product, promotions) => {
    if (!(product && product[0])) return [];
    return ProductFactory.setPromotions(ProductFactory.create(product[0]), promotions);
};

const actions = {
    getProductsCollection(id) {
        return Promise.all([
            ProductService.getPromotions(),
            ProductService.getByURl(`/busca?fq=${id}`)
        ]).then(results => {
            const promotions = results[0];
            const productsData = results[1];

            const products = productsData && productsData.data ? productsData.data.map(product => {
                return ProductFactory.setPromotions(ProductFactory.create(product), promotions);
            }) : [];

            AppDispatcher.dispatch({
                type: actionsType.GET_PRODUCTS,
                payload: {
                    id,
                    products
                }
            });

            return products;

        });
    },
    getProductsBySkus(skus, school = false) {
        return Promise.all([
            ProductService.getPromotions(),
            ListService.productsSkus(skus)
        ]).then(results => {
            const promotions = results[0];
            const productsData = results[1];
            
            const products = productsData ? productsData.map(product => {
                return ProductFactory.setPromotions(ProductFactory.create(product), promotions);
            }) : [];

            AppDispatcher.dispatch({
                type: actionsType.GET_PRODUCTS_SKU,
                payload: {
                    id: JSON.stringify(skus),
                    products
                }
            });
            if(school){
                setTimeout(()=> PubSub.dispatch('GET_PRODUCTS_SCHOOL', products), 0);
            }
            return results;
        });
    },
    
    searchProducts(search) {
        return Promise.all([
            ProductService.getSearchProducts(search),
            ProductService.getPromotions()
        ]).then(results => {
            if(!results) return [];
            const products = productsFactory(results[0], results[1]);

            AppDispatcher.dispatch({
                type: actionsType.GET_SEARCH_PRODUCTS,
                payload: {
                    id: 'search',
                    products
                }
            });

            return products;
        });
    },
    getShelfProducts(url) {
        return Promise.all([
            ProductService.getByURl(url, 2),
            ProductService.getPromotions()
        ]).then(results => {
            const products = productsFactory(results[0].data, results[1]);

            AppDispatcher.dispatch({
                type: actionsType.GET_SHELF_PRODUCTS,
                payload: {
                    id: 'shelf',
                    products
                }
            });

            return results[0];
        });
    },
    getProduct(slug) {
        return Promise.all([
            ProductService.get(slug),
            ProductService.getPromotions()
        ]).then(results => {
            const product = productFactory(results[0], results[1]);

            AppDispatcher.dispatch({
                type: actionsType.GET_PRODUCT,
                payload: {
                    id: 'product',
                    products: [product]
                }
            });

            return product;
        });
    },
    getFrequentProducts() {
        return Promise.all([
            ProductService.getFrequentProducts(),
            ProductService.getPromotions()
        ]).then(results => {
            if(results[0] && results[0].length > 1) {
                const products = productsFactory(results[0], results[1]);

                AppDispatcher.dispatch({
                    type: actionsType.GET_SHELF_PRODUCTS,
                    payload: {
                        id: 'frequent-products',
                        products
                    }
                });
            }

            return results[0];
        });
    }
};

export default actions;
